import { BaseDataService } from './Base/BaseDataService';
import {
    ControlTemplateScope,
    ControlTemplatesListApiDataResponse,
} from '../Models/ControlTemplates/ControlTemplates';
import { XHRRequestCanceler } from '../../Libs/xhr/XHRRequestCanceler';
import { ApiUrls } from '../Models/ApiUrls';

export interface IControlTemplatesDataService {
    getControlTemplateList: (
        state: boolean,
        scope: ControlTemplateScope,
        cts: XHRRequestCanceler,
        page?: number,
        count?: number
    ) => Promise<ControlTemplatesListApiDataResponse>;
}

class ControlTemplatesDataService extends BaseDataService implements IControlTemplatesDataService {
    getControlTemplateList = (
        state: boolean,
        scope: ControlTemplateScope,
        cts: XHRRequestCanceler,
        page?: number,
        count?: number
    ) => {
        return this.get<ControlTemplatesListApiDataResponse>(
            ApiUrls.CHECK_TEMPLATE_LIST,
            cts,
            {
                params: {
                    is_active: state,
                    scope: scope,
                    page: page,
                    count: count,
                },
            }
        );
    };
}

const ControlTemplatesDataServiceName = 'ControlTemplatesDataService';
export { ControlTemplatesDataService, ControlTemplatesDataServiceName };
